import type { JSX } from 'react'
import type { PayrollSource } from '../payrollSource'

const OPTIONS: readonly { source: PayrollSource; label: string; preview: boolean }[] = [
  { source: 'payroll-tab', label: 'Payroll tab', preview: false },
  { source: 'gospel', label: 'GOSPEL total', preview: true },
]

// One line under the control saying where the payroll figure on screen comes
// from. Both states carry a line, so flipping never moves the charts below,
// and a screenshot always says which numbers it shows.
const HINT: Record<PayrollSource, string> = {
  'payroll-tab': "Payroll tab: rebuilt from each row of the 'ZK Payroll' tab.",
  gospel: "GOSPEL: 'Actual AP (Confirmed)' row, incl. sheet adjustments",
}

// Shown instead of the switch once it is retired (PAYROLL_SOURCE_LOCKED):
// the same line in the same place, so the charts don't move and a screenshot
// still says which payroll figure it shows.
const NOTE: Record<PayrollSource, string> = {
  'payroll-tab': "Payroll: rebuilt from each row of the 'ZK Payroll' tab.",
  gospel: "Payroll: GOSPEL 'Actual AP (Confirmed)' row, incl. sheet adjustments.",
}

export function PayrollSourceNote({ source }: { source: PayrollSource }): JSX.Element {
  return (
    <div className="payroll-source">
      <p className="payroll-source-hint">{NOTE[source]}</p>
    </div>
  )
}

// Same segmented control as the time window (native radios, visually hidden):
// it governs every chart built on the payroll total, so it sits above them all.
export function PayrollSourceSwitch({
  source,
  onChange,
}: {
  source: PayrollSource
  onChange: (next: PayrollSource) => void
}): JSX.Element {
  return (
    <div className="payroll-source">
      <fieldset className="window-fieldset">
        <legend className="window-legend">Payroll source</legend>
        <div className="window-options">
          {OPTIONS.map((option) => (
            <label
              key={option.source}
              className={option.source === source ? 'window-option checked' : 'window-option'}
              title={
                option.preview
                  ? 'Preview: use the GOSPEL tab’s Actual AP (Confirmed) row as the payroll figure. Your choice is remembered on this device.'
                  : undefined
              }
            >
              <input
                type="radio"
                name="payroll-source"
                value={option.source}
                checked={option.source === source}
                onChange={() => onChange(option.source)}
              />
              {option.label}
              {option.preview && <span className="preview-tag">preview</span>}
            </label>
          ))}
        </div>
      </fieldset>
      <p className="payroll-source-hint">{HINT[source]}</p>
    </div>
  )
}
